import { useCallback, useEffect, useState } from 'react';

import {
  IBudgetServiceResponse,
  fetchBudgetFailureModes,
  fetchBudgetServices,
} from '../../../../api/fetchBudget';
import BudgetSelectCustom from './BudgetSelectCustom';

interface IBudgetServiceSelectsProps {
  serviceId: string;
  failureModeId?: string;
  onChangeItem: (itemId: string, serviceData?: IBudgetServiceResponse) => void;
  onChangeModoFalha: (modoFalhaId: string) => void;
}

const BudgetServiceSelects = (props: IBudgetServiceSelectsProps) => {
  const [serviceId, setServiceId] = useState<string>(props.serviceId);
  const [failureModeId, setFailureModeId] = useState<string | undefined>(props.failureModeId);

  const loadServiceData = useCallback(
    async (
      searchTerm: string,
      limit: number,
    ): Promise<Array<{ id: string; label: string; serviceData?: IBudgetServiceResponse }>> => {
      const hasSearchTerm = searchTerm && searchTerm.trim() !== '';
      const services = await fetchBudgetServices(hasSearchTerm ? searchTerm : undefined, limit);

      const mockServices = [
        {
          id: 'CORRETIVA',
          label: 'Corretiva',
        },
        {
          id: 'DESGASTE',
          label: 'Desgaste',
        },
      ];

      const searchTermLower = searchTerm.toLowerCase();
      const filteredMockServices = mockServices.filter((mockService) => {
        return (
          !hasSearchTerm ||
          mockService.label.toLowerCase().includes(searchTermLower) ||
          mockService.id.toLowerCase().includes(searchTermLower) ||
          searchTermLower.includes('revisão') ||
          searchTermLower.includes('revisao') ||
          searchTermLower.includes('corretiva') ||
          searchTermLower.includes('desgaste')
        );
      });

      const shouldIncludeMock = filteredMockServices.length > 0;

      if (shouldIncludeMock) {
        const servicesToAdd = filteredMockServices.filter(
          (mockService) => !services.some((s) => s.id === mockService.id)
        );
        if (servicesToAdd.length > 0) {
          return [...servicesToAdd, ...services].slice(0, limit);
        }
      }

      return services;
    },
    [],
  );

  const loadFailureModeData = useCallback(
    async (searchTerm: string, limit: number): Promise<Array<{ id: string; label: string }>> => {
      const hasSearchTerm = searchTerm && searchTerm.trim() !== '';
      const failureModes = await fetchBudgetFailureModes(
        undefined,
        hasSearchTerm ? searchTerm : undefined,
        limit,
      );
      return failureModes;
    },
    [],
  );

  useEffect(() => {
    setServiceId(props.serviceId);
  }, [props.serviceId]);

  useEffect(() => {
    if (props.serviceId === 'CORRETIVA') {
      setFailureModeId(props.failureModeId);
    } else {
      setFailureModeId(undefined);
    }
  }, [props.failureModeId, props.serviceId]);

  const handleServiceChange = (
    option: { id: string; label: string; serviceData?: IBudgetServiceResponse } | undefined,
  ) => {
    const newServiceId = option?.id || '';
    setServiceId(newServiceId);

    if (newServiceId !== 'CORRETIVA') {
      setFailureModeId(undefined);
      props.onChangeModoFalha('');
    }
    props.onChangeItem(newServiceId, option?.serviceData);
  };

  const handleFailureModeChange = (option: { id: string; label: string } | undefined) => {
    const newFailureModeId = option?.id || '';
    setFailureModeId(newFailureModeId);
    props.onChangeModoFalha(newFailureModeId);
  };

  const showFailureMode = serviceId === 'CORRETIVA';

  return (
    <div className="flex flex-col sm:flex-row gap-4 flex-1 w-full">
      <div className="w-full sm:w-[250px]">
        <BudgetSelectCustom
          value={[serviceId]}
          onChange={handleServiceChange}
          loadData={loadServiceData}
          label="Item *"
          openOnFocus={false}
          initialLimit={10}
          inputBorderColor="#14b8a6"
          inputBackgroundColor="#ffffff"
          dropdownBackgroundColor="#ffffff"
          highlightedOptionColor="#3b82f6"
          selectedOptionColor="#e5e7eb"
        />
      </div>
      {showFailureMode && (
        <div className="w-full sm:w-[250px]">
          <BudgetSelectCustom
            value={failureModeId ? [failureModeId] : []}
            onChange={handleFailureModeChange}
            loadData={loadFailureModeData}
            label="Modo de falha"
            openOnFocus={false}
            initialLimit={10}
            inputBorderColor="#14b8a6"
            inputBackgroundColor="#ffffff"
            dropdownBackgroundColor="#ffffff"
            highlightedOptionColor="#3b82f6"
            selectedOptionColor="#e5e7eb"
          />
        </div>
      )}
    </div>
  );
};

export default BudgetServiceSelects;
